import {customFormService} from '../../services/customForm';
import {settings} from '../../common/setting';
import {URLS, $subscriber, cr} from 'fire-wind-water';
import {user} from '../../controllers/user';

function getForm(info) {
  if (!info.customFormId) {
    return;
  }
  customFormService.getCustomForm(info, (res) => {
    if (res.result === 0) {
      res.content.customFormId = info.customFormId;
      $subscriber.emit('s-load-customform', res.content);
    } else {
      console.error(res);
    }
  });
}

export function getCustomForm() {
  const info = {
    tenantId: settings.tenantId,
    customFormId: settings.customFormId,
    globalUserId: user.globalUserId
  };
  if (cr.isArray(info.customFormId)) {
    info.customFormId = info.customFormId[0];
  }
  if (settings.isPreview) {
    info.tenantId = URLS.getURL('tid');
    $subscriber.subscribe('s-load-components', res => {
      const customFormIds = [];
      cr.each(res.items, d => {
        if (d.type === 'CUSTOMFORM') {
          customFormIds.push(d.historyContent.content.customFormId);
        }
      });
      info.customFormId = customFormIds[0];
      settings.customFormId = info.customFormId;
      getForm(info);
    });
  } else {
    getForm(info);
  }
}